import { downloadRequest } from '@helpers/api';

/**
 * Downloads ECSL list
 * @param {string} standardTemplateId - Standard template id string
 * @returns {Promise<*|Object>}
 */
export const downloadECSLExcel = (standardTemplateId: string): Promise<unknown> =>
  downloadRequest(`vFile/ecslDownloadExcel/${standardTemplateId}/`);
